const vanillaTextMask = require("vanilla-text-mask/dist/vanillaTextMask.js");

export function phoneMask(el) {
    if(!el) return;
    el.addEventListener('focus', () => {
      if (el.classList.contains('activated')) return;
      el.classList.add("activated");
      el.value = '+'
    });

    vanillaTextMask.maskInput({
      inputElement: el,
      mask: ['+', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      guide: false
    })
}
